// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"App_wrapper__1it9D","aside":"App_aside__uHFWJ","cover":"App_cover__f0BFy","main":"App_main__2T2Qp"};